import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';

export const VoiceRejectButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<IconButton
			shape="circle"
			isTooltipDisabled={false}
			icon={(iconProps) => <CrossIcon {...iconProps} label={''} />}
			appearance="subtle"
			onClick={onClick}
			label="Reject"
		/>
	);
};
